import axios from 'axios';
import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';
import { toast } from 'react-toastify';
import { push } from 'redux-router';
import validator from 'services/validator.js';
import validate from 'validate.js';
import _ from 'lodash';

const {
  addWebinars,
  addRequestError,
  addUsersWebinars,
  updateWebinar,
  loadVimeoVideoDataSaga,
  setTempWebinar,
  addErrorsSaga,
  addValidateError,
  cleanErrors,
  addAdminWebinars,
  addAdminDashboardWebinars,
  startRequest,
  endRequest,
  setWebinars
} = actions;

const {
  LOAD_WEBINARS_SAGA,
  API_WEBINARS,
  LOAD_USERS_WEBINARS_SAGA,
  LOAD_WEBINAR_SAGA,
  CREATE_WEBINAR_SAGA,
  UPDATE_WEBINAR_SAGA,
  DELETE_WEBINAR_SAGA,
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  PREVIOUS_WEBINARS,
  API_UPCOMING_WEBINARS,
  API_PREVIOUS_WEBINARS,
  API_CURRENT_WEBINARS,
  API_USERS_WEBINARS,
  API_ADMIN_WEBINARS,
  LOAD_ADMIN_WEBINARS_SAGA,
  LOAD_ADMIN_WEBINAR_SAGA,
  ADMIN_DELETE_WEBINARS_SAGA,
  LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA,
  API_DASHBOARDS,
  API_LIVE_WEBINARS,
  API_RECORDED_WEBINARS,
  RELOAD_ALL_DASHBOARD_WEBINARS_SAGA,
  RECORDED_WEBINARS
} = constants;

function * lastLoadedPage (webinarType) {
  return yield select((state) => (state.webinars[webinarType].page));
}

function * lastLoadedCPDpage (webinarType) {
  return yield select((state) => (state.webinars.usersWebinars[webinarType].page));
}

const apiLoadWebinars = (webinarType, params) => (
  axios.get(eval(`API_${webinarType}`), { params: {
    ...params
  }})
)

const apiLoadWebinar = (id, params = {}) => (
  axios.get(`${API_WEBINARS}/${id}`, {
    params: {
      ...params
    }
  })
);

const apiLoadAdminWebinar = ( id, params = {}) => (
  axios.get(`${API_ADMIN_WEBINARS}/${id}`, {
    params: {
      ...params
    }
  })
);

const apiCreateWebinar = (webinar) => (
  axios.post(API_ADMIN_WEBINARS, webinar)
);

const apiUpdateWebinar = (id, webinar) => (
  axios.put(`${API_ADMIN_WEBINARS}/${id}`, webinar)
);
const apiLoadUsersWebinars = (webinarType, page, filters) => {
  const path = eval(`API_${webinarType}`);
  return axios.get(path, {
    params: {
      page: page,
      per_page: 3,
      subscribed_order: true,
      ...(filters || {})
    }
  });
}

const apiLoadAdminWebinars = (page, query) => (
  axios.get(API_ADMIN_WEBINARS, {
    params: {
      page,
      per_page: 5,
      ...query
    }
  })
);

const apiLoadAdminDashboardWebinars = (page) => (
  axios.get(`${API_DASHBOARDS}?page=${page}&&per_page=5`)
);

const apiDeleteWebinars = (webinar_ids) => {
  return axios.post(API_ADMIN_WEBINARS + '/destroy', {
    webinar_ids: webinar_ids
  })
}

const formatRequestData = (webinar) => {
  let data = new FormData();

  Object.keys(webinar).forEach(field => {
    data.append(`webinar[${field}]`, webinar[field]);
  })
  data.append('webinar[doctor_avatar]', webinar.doctor_avatar);

  if (webinar.webinar_type != 'online') {
    data.delete('webinar[zoom_uid]');
    data.delete('webinar[start_date]');
    data.delete('webinar[end_date]');
  }

  data.delete('webinar[counties]');
  data.delete('webinar[user_types]');
  data.delete('webinar[disciplines]');
  data.delete('webinar[assignedUsers]');
  data.delete('webinar[assigned_ids]');
  webinar.counties.forEach((county, index) => {
    data.append(`webinar[counties][]`, county)
  });
  webinar.user_types.forEach((role, index) => {
    data.append(`webinar[user_types][]`, role)
  });
  webinar.disciplines.forEach((discipline, index) => {
    data.append(`webinar[disciplines][]`, discipline)
  });
  if (webinar.assignedUsers) {
    webinar.assignedUsers.forEach((assignedUser, index) => {
      data.append(`webinar[assigned_ids][]`, parseInt(assignedUser));
    });
  }

  data.delete('webinar[spd_quizzes_attributes]');

  const quizzes = webinar.spd_quizzes_attributes.filter(e => !!e.question);
  if (quizzes && quizzes.length)
    quizzes.forEach(quiz => {
      if(quiz.id)
        data.append('webinar[spd_quizzes_attributes[]][id]', quiz.id);
      if(quiz._destroy)
        data.append('webinar[spd_quizzes_attributes[]][_destroy]', quiz._destroy);
      data.append('webinar[spd_quizzes_attributes[]][question]', quiz.question);
      data.append('webinar[spd_quizzes_attributes[]][correct]', quiz.correct);
    })
  return data;
}

function* loadWebinarsSaga({ webinarType, page, params = {} }) {
    try {
      const loadedPage = yield call(lastLoadedPage, webinarType);
      if (loadedPage >= page && loadedPage != 0) return;
      const newPage = loadedPage + 1;
      const isLogged = yield select(store => !_.isEmpty(store.users.user));
      const userRole = yield select(store => (store.users.user.user_type));

      let per_page_n;
      webinarType === 'PREVIOUS_WEBINARS' ? per_page_n = 10 : per_page_n = 3;

      const skipCounties = () => {
        if (['consultant', 'hospital_doctor', 'sponsor'].indexOf(userRole)!==-1 ) {
          return { filter_by_user_types: true }
        }
        return { filter_by_county: true, filter_by_user_types: true }
      }

      const filterByDisciplines = () => {
        if (params.disciplines && params.disciplines.length == 0) {
          return {}
        }

        return {filter_by_disciplines: true}
      }

      const paramsForRequest = {
        page: newPage,
        per_page: per_page_n,
        ...(isLogged ? skipCounties() : {}),
        ...filterByDisciplines(),
        ...params
      };

      const response = yield call(apiLoadWebinars, webinarType, paramsForRequest);
      const webinars = response.data.webinars;
      const pages = response.data.pages;
      const totalCount = response.data.count;
      if (!webinars.length) return;
      yield put(addWebinars(webinarType, newPage, webinars, pages, totalCount));

    } catch (e) {
      yield put(addRequestError(e.response))
    }
}

function* reloadWebinars({ params = {} }) {
  try {
    const [upcoming, current, previous] = yield select(state => [
      state.webinars[UPCOMING_WEBINARS],
      state.webinars[CURRENT_WEBINARS],
      state.webinars[PREVIOUS_WEBINARS]
    ]);

    const perPageUpcoming = upcoming.values.length;
    const perPageCurrent = current.values.length;
    const perPagePrevious = previous.values.length;

    const filterByDisciplines = () => {
      if (params.disciplines && params.disciplines.length == 0) {
        return {}
      }

      return {filter_by_disciplines: true}
    }

    const userRole = yield select(store => (store.users.user.user_type));
    const filterByCounty = () => {
      if (['consultant', 'hospital_doctor', 'sponsor'].indexOf(userRole)!==-1 ) {
        return {}
      }
      return {filter_by_county: true}
    };


    const upcomingResp = yield call(apiLoadWebinars, UPCOMING_WEBINARS, {
      page: 1,
      per_page: perPageUpcoming || 3,
      filter_by_user_types: true,
        ...params,
        ...filterByCounty(),
        ...filterByDisciplines()
    })

    const currentResp = yield call(apiLoadWebinars, CURRENT_WEBINARS, {
      page: 1,
      per_page: perPageCurrent || 3,
      filter_by_user_types: true,
        ...params,
        ...filterByCounty(),
        ...filterByDisciplines()
    });

    const previousResp = yield call(apiLoadWebinars, PREVIOUS_WEBINARS, {
      page: 1,
      per_page: perPagePrevious || 10,
      filter_by_user_types: true,
        ...params,
        ...filterByCounty(),
        ...filterByDisciplines()
    });

    yield put(setWebinars(UPCOMING_WEBINARS, upcomingResp.data.webinars));
    yield put(setWebinars(CURRENT_WEBINARS, currentResp.data.webinars));
    yield put(setWebinars(PREVIOUS_WEBINARS, previousResp.data.webinars));

  } catch (e) {
    console.error(e);
    yield put(addRequestError(e.response))
  }
}

function* loadUsersWebinarsSaga({ page, webinarType }) {
    try {
      const filters = (webinarType == RECORDED_WEBINARS ? ['only_subscribed', 'not_joined', 'published_order'] : ['only_joined']).reduce((result, item) => (
        {...result, [item]: true}
      ), {});
      const loadedPage = yield call(lastLoadedCPDpage, webinarType);
      if (loadedPage >= page && loadedPage != 0) return;
      const newPage = loadedPage + 1;
      const response = yield call(apiLoadUsersWebinars, webinarType, newPage, filters);
      let cpds = response.data.cpd_points || 0;
      const pages = response.data.pages;
      const webinars = response.data.webinars;
      yield put(addUsersWebinars(newPage, webinarType, webinars, pages, cpds));

    } catch (e) {
      console.log(e);
      yield put(addRequestError(e.response))
    }
}

function* loadWebinarSaga({ id, temp = false, loadVideo = false, trackView = false }) {
  try {
    const params = trackView ? { track_view: true } : {};
    const response = yield call(apiLoadWebinar, id, params);
    const webinar = response.data.webinar;
    if (temp) {
      yield put(setTempWebinar(webinar))
      yield put(loadVimeoVideoDataSaga(webinar.vimeo_url))
    } else {
      yield put(updateWebinar(webinar));
    }

  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response))
  }
}

function* loadAdminWebinarSaga({ id, temp = false, loadVideo = false, trackView = false }) {
  try {
    const params = trackView ? { track_view: true } : {};
    const response = yield call(apiLoadAdminWebinar, id, params);
    const webinar = response.data.webinar;
    if (temp) {
      yield put(setTempWebinar(webinar))
      yield put(loadVimeoVideoDataSaga(webinar.vimeo_url))
    } else {
      yield put(updateWebinar(webinar));
    }

  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response))
  }
}

function* createWebinarSaga({ webinar }) {
  try {
    if (yield select(store => store.requests.indexOf('webinar_create') != -1))
      return;

    yield put(startRequest('webinar_create'));

    const errors = validator.validate(webinar, 'webinar');
    if (errors) {
      yield put(addValidateError(CREATE_WEBINAR_SAGA, errors));
      yield put(endRequest('webinar_create'));
      return;
    } else {
      yield put(cleanErrors(CREATE_WEBINAR_SAGA))
    }
    const webinarRequestData = yield call(formatRequestData, webinar);
    const response = yield call(apiCreateWebinar, webinarRequestData);
    const createdWebinar = response.data.webinar;
    toast.success('Webinar successfully created!');
    yield put(push('/webinars/'));
    yield put(endRequest('webinar_create'));
  } catch (e) {
    yield put(endRequest('webinar_create'));
    yield put(addErrorsSaga(CREATE_WEBINAR_SAGA, e.response))
  }
}

function* updateWebinarSaga({ webinar }) {
  try {
    const errors = validator.validate(webinar, 'webinar');
    if (errors) {
      yield put(addValidateError(UPDATE_WEBINAR_SAGA, errors));
      return;
    } else {
      yield put(cleanErrors(UPDATE_WEBINAR_SAGA))
    }

    if (webinar.spd_quizzes_attributes.filter(e => !!e.question && !e._destroy).length < 10 && webinar.vimeo_url) {
      toast.error('CPD Quiz should contain >= 10 questions');
      return;
    }

    const webinarRequestData = yield call(formatRequestData, webinar);
    const response = yield call(apiUpdateWebinar, webinar.id, webinarRequestData);
    const updatedWebinar = response.data.webinar;
    toast.success('Webinar successfully updated!')
    yield put(push('/webinars/'))
    yield put(endRequest('webinar_update'));
  } catch (e) {
    console.log(e);
    yield put(addErrorsSaga(UPDATE_WEBINAR_SAGA, e.response))
  }
}

function* deleteWebinars({ webinar_ids }) {
  if (!webinar_ids.length)
    return;
  const webinarIds = webinar_ids;
  try {
    yield call(apiDeleteWebinars, webinarIds);
    toast.success('Webinars successfully deleted!');
    const query = yield select(state => state.webinars.adminWebinars.query) || {};
    const page = yield select(state => state.webinars.adminWebinars.page) || 1;
    yield call(loadAdminWebinars, { page, query });
  } catch (e) {
    console.log(e);
    yield put(addErrorsSaga(ADMIN_DELETE_WEBINARS_SAGA, e.response))
  }
}

function* loadAdminWebinars({ page = 1, query = {} }) {
  try {
    const response = yield call(apiLoadAdminWebinars, page, query);
    const webinars = response.data.result.webinars;
    const count = response.data.result.count;
    const totalPages = response.data.result.total_pages;
    yield put(addAdminWebinars(webinars, count, page, totalPages, query));

  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response))
  }
}

function* loadAdminAdminDashboardWebinars({ page }) {
  try {
    const response = yield call(apiLoadAdminDashboardWebinars, page);
    const webinars = response.data.result.webinars;
    const count = response.data.result.count;
    const totalPages = response.data.result.total_pages;
    const totalUsers = response.data.result.total_users;
    yield put(addAdminDashboardWebinars(webinars, count, page, totalPages, totalUsers));
  } catch (e) {
    console.log(e);
    yield put(addRequestError(e.response))
  }
}

function* __loadWebinarSaga() {
  yield takeEvery(LOAD_WEBINAR_SAGA, loadWebinarSaga);
}

function* __loadAdminWebinarSaga() {
  yield takeEvery(LOAD_ADMIN_WEBINAR_SAGA, loadAdminWebinarSaga)
}

function* __loadWebinarsSaga() {
  yield takeEvery(LOAD_WEBINARS_SAGA, loadWebinarsSaga);
}

function* __loadUsersWebinarsSaga() {
  yield takeEvery(LOAD_USERS_WEBINARS_SAGA, loadUsersWebinarsSaga);
}

function* __createWebinarSaga() {
  yield takeEvery(CREATE_WEBINAR_SAGA, createWebinarSaga);
}

function* __updateWebinarSaga() {
  yield takeEvery(UPDATE_WEBINAR_SAGA, updateWebinarSaga);
}

function* __deleteWebinarSaga() {
  yield takeEvery(ADMIN_DELETE_WEBINARS_SAGA, deleteWebinars);
}

function* __loadAdminWebinars() {
  yield takeEvery(LOAD_ADMIN_WEBINARS_SAGA, loadAdminWebinars)
}

function* __loadDashboardAdminWebinars() {
  yield takeEvery(LOAD_ADMIN_WEBINARS_SAGA, loadAdminWebinars)
}

function* __loadAdminAdminDashboardWebinarsSaga() {
  yield takeLatest(LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA, loadAdminAdminDashboardWebinars)
}

function* __reloadWebinars() {
  yield takeEvery(RELOAD_ALL_DASHBOARD_WEBINARS_SAGA, reloadWebinars)
}

export {
  __loadWebinarsSaga,
  __loadUsersWebinarsSaga,
  __loadWebinarSaga,
  __loadAdminWebinarSaga,
  __createWebinarSaga,
  __updateWebinarSaga,
  __deleteWebinarSaga,
  __loadAdminWebinars,
  __loadAdminAdminDashboardWebinarsSaga,
  __reloadWebinars
};



/** WEBPACK FOOTER **
 ** ./src/sagas/webinars.js
 **/